module.exports = __webpack_public_path__ + "static/media/kallberga_etapp.3713fa83.png";